import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { getProvinces, getCities, PATTERNS } from "../../../../globals";

@Component({
    selector: 'modal-address',
    templateUrl: '../../templates/partials/modal-address.html'
})

export class ModalAddressComponent implements OnInit {
    @Input() showModal;
    @Input() data;
    @Output() emitCloseModal = new EventEmitter();
    @ViewChild('addressModal') public assignModal:ModalDirective;
    public addressData: FormGroup;
    public cities;
    public provinces;
    
    constructor(private _fb: FormBuilder) { 
        this.cities = getCities();
        this.provinces = getProvinces();
    }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public addAddress() {
       var data = this.parseDataToSend();
      this.emitCloseModal.emit({action: "close", data: data, type: "add"});
    }

    public updateAddress(address: object) {
        var data = this.parseDataToSend();
        data["id_address"] = this.data["data"]["id_address"];
        data["index"] = this.data["data"]["index"];
        this.emitCloseModal.emit({action: "close", data: data, type: "edit"});
    }

    private parseDataToSend() {
        var city = this.getCity(this.addressData.controls.city.value);
        return {
            address: this.addressData.controls.street.value,
            number: this.addressData.controls.number.value,
            floor: this.addressData.controls.floor.value,
            door: "",
            city: this.addressData.controls.city.value,
            province: city["province"],
            country: "es",
            zip_code: this.addressData.controls.postalCode.value,
            id_available_city: city["id"]
        }
    }

    private getCity(value) {
        for(var i = 0; i < this.cities.length; i++){
            var element = this.cities[i];
            if(element.name == value){
                return element;
            }
        }
    }

    public removeAddress() {
        this.emitCloseModal.emit({action: "close", data: this.data["data"], type: "remove"});
    }

    ngOnChanges(value) {
        if(this.data != null && this.data["data"] != null){
            this.addressData = this._fb.group({
                street: [this.data["data"]["address"], [Validators.required, Validators.minLength(4)]],
                number: [this.data["data"]["number"], [Validators.required]],
                floor: [this.data["data"]["floor"], [Validators.required]],
                city: [this.data["data"]["name"], [Validators.required]],
                province: [this.data["data"]["city"], [Validators.required]],
                postalCode: [this.data["data"]["zip_code"], [Validators.required, Validators.pattern(PATTERNS["postalCode"])]],
            });
        }
        (this.showModal) ? this.assignModal.show() : this.assignModal.hide();
    }

    ngOnInit() { 
        this.addressData = this._fb.group({
            street: ['', [Validators.required, Validators.minLength(4)]],
            number: ['', [Validators.required]],
            floor: ['', [Validators.required]],
            city: ['', [Validators.required]],
            province: ['', [Validators.required]],
            postalCode: ['', [Validators.required, Validators.pattern(PATTERNS["postalCode"])]],
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/modal-address.component.ts